<template>
  <v-container fluid>
    <v-row align="center" justify="center">
      <v-col cols="6">
        <v-card>
          <v-card-title>Add a Product to {{pmsConnDetails.usr}}</v-card-title>
          <v-card-subtitle>{{pmsConnDetails.pmsType}} - {{pmsConnDetails.brand}}</v-card-subtitle>
          <v-card-text>
            <v-radio-group v-model="productType" :mandatory="true">
              <v-radio v-if="pmsConnDetails.brand != 'PY'"
                label="MyHealth 1st Products (inc Online Appointments, EasyRecalls, etc)"
                value="mh1"
              ></v-radio>
              <v-radio v-if="pmsConnDetails.brand != 'PY'" :disabled="true" label="GoBookings Online Appointments" value="gbs"></v-radio>
              <v-radio v-if="pmsConnDetails.brand == 'PY'" :disabled="true" label="PetYeti Online Appointments" value="gbspy"></v-radio>
              <v-radio :disabled="true" label="SMS Reminders" value="smsRemimnders"></v-radio>
              <v-radio :disabled="true" label="EasyEngage" value="easyEngage"></v-radio>
              <v-radio :disabled="true" label="EasyCheckin" value="easyCheckin"></v-radio>
            </v-radio-group>
          </v-card-text>
          <v-card-actions>
              <v-btn :to="{ name: 'PmsConnProducts', params: { sub: $route.params.sub }}" color="normal" >Back to Product List</v-btn>
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="goToAddProduct()">Continue</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
export default {
  props: {
    pmsConnDetails: Object,
    pmsInfo: Object,
    pmsInfoLoading: Boolean,
  },
  data: function() {
    return {
      productType: ""
    }
  },
  methods: {
    goToAddProduct: function () {
      switch (this.productType) {
        case "mh1":
          this.$router.push({ name: "AddMh1" });
          break;
      }
    },
  },
};
</script>